.TextOverflow {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
